module.exports = __webpack_public_path__ + "img/goalbook-1.a85afa0a.webp";